import { useMediaQuery } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';

import { PWADisconnectedBanner } from '@/components/pwa/PWADisconnectedBanner';
import { PWAInstallPrompt } from '@/components/pwa/PWAInstallPrompt';
import { PWAUpdateBanner } from '@/components/pwa/PWAUpdateBanner';
import { PullToRefresh } from '@/components/pwa/PullToRefresh';
import { pullToRefreshAvailable, pullToRefreshEnabled } from '@/components/pwa/pullGesture';
import { useInstallPrompt } from '@/components/pwa/useInstallPrompt';
import { useOnlineStatus } from '@/components/pwa/useOnlineStatus';
import { useOverlayOpen } from '@/components/pwa/useOverlayOpen';
import { usePwaUpdate } from '@/components/pwa/usePwaUpdate';
import { isPaymentPage } from '@/lib/paymentTelemetryPrivacy';

export function PwaChrome() {
  const online = useOnlineStatus();
  const onCustomerSurface = isPaymentPage(useLocation().pathname);
  const { needRefresh, update } = usePwaUpdate(!onCustomerSurface);
  const overlayOpen = useOverlayOpen();
  const { canInstall, install, dismiss } = useInstallPrompt(onCustomerSurface || overlayOpen);
  const isMobile = useMediaQuery('(max-width: 768px)') ?? false;
  const standaloneDisplay = useMediaQuery('(display-mode: standalone)') ?? false;
  const coarsePointer = useMediaQuery('(pointer: coarse)') ?? false;
  const pullGate = {
    standalone: standaloneDisplay || (navigator as Navigator & { standalone?: boolean }).standalone === true,
    coarsePointer,
    customerSurface: onCustomerSurface,
    overlayOpen,
  };

  return (
    <>
      {pullToRefreshAvailable(pullGate) && <PullToRefresh enabled={pullToRefreshEnabled(pullGate)} />}
      <PWADisconnectedBanner online={online} onRetry={() => window.location.reload()} />
      <PWAUpdateBanner open={needRefresh && !onCustomerSurface} onRefresh={update} />
      <PWAInstallPrompt
        open={canInstall && isMobile && !onCustomerSurface}
        onInstall={() => void install()}
        onDismiss={dismiss}
      />
    </>
  );
}
